import Vue from "vue";

Vue.filter("commaSeparator", (value: number | string, lang: string) => {
  if (value === null || value === undefined) {
    return "";
  }
  
  // Spanish and German use the same format
  const usesEuropeanFormat = lang === "de" || lang === "es";
  const fractionSeparator = typeof value === "string" && usesEuropeanFormat ? "," : ".";
  const [integerPart, fractionalPart] = value.toString().split(fractionSeparator);
  const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, usesEuropeanFormat ? "." : ",");
  const formattedFractionSeparator = usesEuropeanFormat ? "," : ".";

  return fractionalPart
    ? `${formattedIntegerPart}${formattedFractionSeparator}${fractionalPart}`
    : formattedIntegerPart;
});

Vue.filter("fractionSeparator", (value: any, lang: string) => {
  if (value === null || value === undefined) {
    return "";
  }
  
  // Spanish and German use comma as decimal separator
  const usesEuropeanFormat = lang === "de" || lang === "es";
  return value.toString().replace(".", usesEuropeanFormat ? "," : ".");
});

Vue.filter("roundDecimals", (value: number, decimals: number = 2) => {
  if (value === null || value === undefined) {
    return "";
  }
  
  const factor = Math.pow(10, decimals);
  return Math.round(value * factor) / factor;
});
